// shadcn/ui's class helper: conditional classes, with later Tailwind classes winning.
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
